<script>
    export let label = "";
    export let disabled = false;
    export let loading = false;
    export let offset = 3;
    $: size = 12 - offset;
</script>

<div class="form-group">
    <div class="col-sm-offset-{offset} col-sm-{size}">
        <button
            type="button"
            class="btn btn-primary"
            disabled={disabled || loading}
            on:click
        >
            {#if loading}
                <span class="glyphicon glyphicon-refresh spinning" />
            {/if}
            {label}</button
        >
        <slot />
    </div>
</div>
